export var AzureEnvironment = /*#__PURE__*/ function(AzureEnvironment) {
    AzureEnvironment[AzureEnvironment["Public"] = 0] = "Public";
    AzureEnvironment[AzureEnvironment["FairFax"] = 1] = "FairFax";
    AzureEnvironment[AzureEnvironment["Mooncake"] = 2] = "Mooncake";
    AzureEnvironment[AzureEnvironment["BlackForest"] = 3] = "BlackForest";
    return AzureEnvironment;
}({});
const settings = {};
settings[0] = {
    environment: 0,
    defaultCountryCode: 'us',
    defaultLocale: 'en-us',
    allowMSA: true
};
settings[2] = {
    environment: 2,
    defaultCountryCode: 'cn',
    defaultLocale: 'zh-cn',
    allowMSA: false
};
// Settings for the Azure environment
export const AzureEnvironmentSettings = settings[0];
